// styles
import fieldStyles from '../field.module.scss'
import styles from './label.module.scss'

export type LabelProps = {
	readonly label?: string
	readonly required?: boolean
} & React.HTMLAttributes<HTMLSpanElement>

const Label = (props: LabelProps): JSX.Element => {
	const { className, label, required, ...attr } = props

	return (
		<span
			{...attr}
			className={[styles.label, fieldStyles.labelText, className]
				.join(' ')
				.trim()}
		>
			{label}
			{required && <span className={styles.required}>*</span>}
		</span>
	)
}

export default Label
